module.exports = __webpack_public_path__ + "static/media/jq-video.b37e5c4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jq/jq-video.mp4
// module id = wuaF
// module chunks = 1